module.exports = __webpack_public_path__ + "img/text.ed4241cb.png";